import api from "./client";

export async function getVapidKey() {
  const { data } = await api.get("/api/push/vapid-key");
  return data.data.publicKey;
}

export async function saveSubscription(subscription) {
  const { data } = await api.post("/api/push/subscribe", subscription.toJSON());
  return data;
}

export async function removeSubscription(endpoint) {
  const { data } = await api.post("/api/push/unsubscribe", { endpoint });
  return data;
}
